import { ValueOf } from "../type";

export const DocumentSignerKey = {
  DocumentSignBySignerToken: "DOCUMENT_SIGN_BY_SIGNER_TOKEN",
  DocumentSignerDocsPdfPage: "DOCUMENT_SIGNER_DOCS_PDF_PAGE",
} as const;

export type DocumentSignerKeyType = ValueOf<typeof DocumentSignerKey>;
